import classNames from "classnames";
import React, { useCallback } from "react";
import { ArrowCircleIcon } from "../icons/ArrowCircleIcon";
import { lookupColourString } from "../lookups";
import { ContactInformation } from "./ContactInformation";
import { ExternalLinkSelection } from "./ExternalLinkSelection";
import { FormFields, SignUpForm } from "./SignUpForm";

export const FooterView: React.FC<{
  className?: string;
  footer: Queries.FooterFragment;
}> = ({
  footer: { contactInformation, externalLinkSelection, footerContactForm },
}) => {
  const bgColour = "Coal";
  const bgColourClass = lookupColourString(bgColour, "bg");
  const fgColourClass = lookupColourString(bgColour, "textForBg");
  const scrollToTop = useCallback(() => {
    document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  const controlInfo = footerContactForm?.controlInformation as FormFields;
  return (
    <footer
      className={classNames("md:pt-80px pt-60px lg:pt-100px", bgColourClass)}
    >
      <div className="page-grid max-width relative">
        {contactInformation && (
          <div
            className={classNames(
              "col-span-4 col-start-2",
              "md:col-span-4 md:col-start-2 md:row-start-1",
              "lg:col-span-6 lg:col-start-3",
              "grid",
              "grid-cols-5",
              fgColourClass,
              "lg:py-100px"
            )}
          >
            {contactInformation.title && (
              <h3
                className={classNames(
                  "col-start-1",
                  "col-span-2",
                  "text-lazer",
                  "h7"
                )}
              >
                {contactInformation.title}
              </h3>
            )}
            <ContactInformation
              information={contactInformation}
              className={classNames("col-start-3", "col-span-3")}
            />
          </div>
        )}
        <div
          className={classNames(
            "my-48px",
            "col-span-4 col-start-2",
            "dashed-line",
            "bg-lazer",
            "text-coal",
            "md:hidden"
          )}
        />
        <div
          className={classNames(
            "hidden",
            "md:col-span-1 md:col-start-6 md:row-span-2 md:row-start-1 md:justify-self-start",
            "lg:col-span-1 lg:col-start-9",
            "dashed-line-y",
            "bg-lazer",
            "text-coal",
            "md:block"
          )}
        ></div>
        {externalLinkSelection && (
          <div
            className={classNames(
              "col-span-4 col-start-2",
              "md:col-span-4 md:ml-40px",
              "md:row-start-2 lg:col-span-6 lg:col-start-3 lg:ml-0",
              "grid grid-cols-5",
              fgColourClass
            )}
          >
            {externalLinkSelection.title && (
              <h3
                className={classNames(
                  "col-start-1",
                  "col-span-2",
                  "text-lazer",
                  "h7"
                )}
              >
                {externalLinkSelection.title}
              </h3>
            )}
            <ExternalLinkSelection
              links={externalLinkSelection.externalLinks}
              className={classNames("col-start-3", "col-span-3")}
            />
          </div>
        )}
        <div
          className={classNames(
            "my-48px",
            "col-span-4 col-start-2",
            "dashed-line",
            "bg-lazer",
            "text-coal",
            "md:hidden"
          )}
        />
        <div className="col-span-4 col-start-2 row-span-2 md:col-span-3 md:col-start-7 lg:col-span-6 lg:col-start-10 lg:py-100px">
          <SignUpForm formControlInfo={controlInfo} />
          <div className="flex w-full justify-end">
            <button
              aria-label="Scroll to top"
              onClick={scrollToTop}
              className="col-start-5 mt-20px md:my-60px"
            >
              <ArrowCircleIcon
                colourClassName="text-lazer"
                className="h-38px rotate-180 justify-self-end"
                aria-hidden="true"
              />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
